<template>
  <div class="personalization-field" data-test-id="message-personalization-accordion">
    <v-expansion-panels accordion class="d-flex full-width personalization-field__panels">
      <v-expansion-panel>
        <v-expansion-panel-header expand-icon="mdi-menu-down">
          <Typography variant="body-1" class="personalization-field__label">
            Personalization
          </Typography>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="personalization-field__shortcodes">
            <InputChip @click="$emit('insert', 'user.firstName')">First Name</InputChip>
            <InputChip @click="$emit('insert', 'user.lastName')">Last Name</InputChip>
            <template v-if="programRelated">
              <InputChip @click="$emit('insert', 'program.name')">Program Name</InputChip>
              <InputChip @click="$emit('insert', 'program.progressPercent')">
                Percent Complete
              </InputChip>
              <InputChip @click="$emit('insert', 'program.progressPercentInverse')">
                Percent Left To Go
              </InputChip>
              <InputChip @click="$emit('insert', 'program.progressToward')">
                Progress Toward
              </InputChip>
              <InputChip @click="$emit('insert', 'program.userStatus')">
                User's Program Status
              </InputChip>
              <template v-if="programHasEndDate">
                <InputChip @click="$emit('insert', 'program.daysRemaining')">
                  Program Days Remaining (x days)
                </InputChip>
                <InputChip @click="$emit('insert', 'program.hoursRemaining')">
                  Program Hours Remaining (x hours)
                </InputChip>
              </template>
            </template>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <Typography variant="caption-2" class="personalization-field__hint">
      Use these personalization tags to dynamically insert user data into the message
    </Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import InputChip from "@/components/generic/InputChip.vue";

export default {
  name: "MessagePersonalizationAccordion",
  components: {
    Typography,
    InputChip,
  },
  props: {
    programRelated: {
      type: Boolean,
      default: false,
    },
    programHasEndDate: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["insert"],
};
</script>

<style scoped>
.personalization-field {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.personalization-field__panels {
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background-color: white;
}

.personalization-field__panels::v-deep .v-expansion-panel {
  background-color: transparent;
}

.personalization-field__panels::v-deep .v-expansion-panel::before {
  box-shadow: none;
}

.personalization-field__panels::v-deep .v-expansion-panel-header {
  padding: 16px 12px;
  min-height: 56px;
}

.personalization-field__panels::v-deep .v-expansion-panel-header--active {
  min-height: 56px;
}

.personalization-field__panels::v-deep .v-expansion-panel-content__wrap {
  padding: 8px 12px 16px;
}

.personalization-field__label {
  color: rgba(0, 0, 0, 0.6);
}

.personalization-field__hint {
  padding: 3px 14px 0;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 0.4px;
}

.personalization-field__shortcodes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
